import { render, staticRenderFns } from "./53.vue?vue&type=template&id=5a8f195c&scoped=true&"
var script = {}
import style0 from "./53.vue?vue&type=style&index=0&id=5a8f195c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8f195c",
  null
  
)

export default component.exports